import React from 'react';
import '../styles/Gallery.css';

function Gallery() {
  const images = [
    { src: '/images/fachada.webp', alt: 'Fachada Ari Lashes' },
    { src: '/images/interior.webp', alt: 'Interior Ari Lashes' },
    { src: '/images/interior_2.webp', alt: 'Interior 2' }
  ];

  return (
    <div className="gallery">
      <div className="section-title">
        <h2>Nuestro Centro</h2>
      </div>
      <div className="gallery-container">
        {images.map((image, index) => (
          <div className="gallery-item" key={index}>
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;